<template>
  <b-button
    :variant="variant"
    @click="init"
  >
    {{ label }}
  </b-button>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/dataInit',
      variant: 'warning',
      label: '初期化の確認',
      confirmed: false
    }
  },

  methods: {
    async init () {
      if (!this.confirmed) {
        this.confirmed = true
        this.variant = 'danger'
        this.label = '実行する'
        return
      }

      this.$store.dispatch('modal/setExec', async () => {
        const result = await this.$store.dispatch(`${this.modelName}/init`)
        if (result) {
          this.$store.dispatch('toast/show', {
            content: '初期化が完了しました。',
            title: 'データの初期化'
          })
        }
      })
    }
  }
}
</script>
